import React from "react";
import {Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import "./App.css";
import Contact from "./pages/Contact/Contact";
import Services from "./components/Services/Services";
import About from "./components/About/About";
function App() {
  return (
 
      <Routes>
        <Route exact path="/" index element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
  );
}

export default App;
